import React from 'react';
import { Link } from 'react-router-dom';
/** lib,const **/
import classNames from 'classnames';
/** styles,images **/
import s from '../../styles/common/header.module.scss';
import MecLogo from 'assets/images/mec-logo.webp';
import { ReactComponent as LogoWhiteSvg } from 'assets/images/logo.svg';

export const Header: React.FC = () => {
  return (
    <header>
      <div className={s.inner}>
        <div className={s.logoBlock}>
          <Link to={'/#top'}>
            <LogoWhiteSvg className={s.logo} />
          </Link>
          <p>三菱地所が事業化検討中<br className={s.largeOnly} />ペット<span className={s.pcOnly}>の</span>コンシェルジュがいる賃貸マンション<span className={s.pcOnly}>　P-man</span></p>
        </div>

        <div className={classNames(s.rightBlock, s.pcOnly)}>
          <a className={s.mecLink} href="https://www.mec.co.jp/" target="_blank" rel="noreferrer">
            <img src={MecLogo} width={150} height={33} alt="三菱地所" />
          </a>
        </div>
      </div>
    </header>
  );
};
